/* noon-style homepage: hero slider, deal countdown, copy-a-code (sections/mx-*.liquid) */
(function(){
  var rtl = document.documentElement.dir === 'rtl';

  function hero(root){
    if(root._mx) return; root._mx = 1;
    var track = root.querySelector('.mxh-track'), slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-dot]'));
    var secs = (+root.dataset.seconds || 5), i = 0, timer = null, hover = false;
    root.style.setProperty('--mxh-t', secs + 's');
    if(slides.length < 2){ var v0 = slides[0] && slides[0].querySelector('video'); if(v0){ v0.loop = true; v0.play && v0.play().catch(function(){}); } return; }

    function vid(n){ return slides[n].querySelector('video'); }
    function schedule(){
      clearTimeout(timer);
      var v = vid(i);
      if(v){
        if(!v.getAttribute('src')) v.src = v.dataset.src;
        v.currentTime = 0;
        var p = v.play(); v.onended = function(){ go(i + 1); };
        if(p && p.catch) p.catch(function(){ timer = setTimeout(function(){ go(i + 1); }, secs * 1000); });
        var d = dots[i] && dots[i].querySelector('i');
        if(d) d.style.animationDuration = (isFinite(v.duration) && v.duration ? v.duration : secs) + 's';
      } else if(!hover){
        timer = setTimeout(function(){ go(i + 1); }, secs * 1000);
      }
    }
    function go(n){
      var prev = vid(i); if(prev){ prev.pause(); prev.onended = null; }
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (rtl ? '' : '-') + (i * 100) + '%)';
      slides.forEach(function(s, k){ s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function(d, k){ d.classList.toggle('on', k === i); var b = d.querySelector('i'); if(b){ b.style.animation = 'none'; b.offsetWidth; b.style.animation = ''; } });
      var nx = vid((i + 1) % slides.length); if(nx && !nx.getAttribute('src')){ nx.preload = 'metadata'; nx.src = nx.dataset.src; }
      schedule();
    }
    var pv = root.querySelector('[data-prev]'), nv = root.querySelector('[data-next]');
    pv && pv.addEventListener('click', function(){ go(i - 1); });
    nv && nv.addEventListener('click', function(){ go(i + 1); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.dataset.dot); }); });
    root.addEventListener('mouseenter', function(){ hover = true; root.classList.add('paused'); if(!vid(i)) clearTimeout(timer); });
    root.addEventListener('mouseleave', function(){ hover = false; root.classList.remove('paused'); if(!vid(i)) schedule(); });
    var x0 = null, y0 = 0, moved = false;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; moved = false; }, {passive:true});
    root.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){ moved = true; go(i + ((dx < 0) !== rtl ? 1 : -1)); }
    }, {passive:true});
    root.addEventListener('click', function(e){ if(moved){ e.preventDefault(); moved = false; } }, true);
    document.addEventListener('visibilitychange', function(){ if(document.hidden){ clearTimeout(timer); var v = vid(i); v && v.pause(); } else schedule(); });
    schedule();
  }

  function timers(){
    [].forEach.call(document.querySelectorAll('[data-ends]'), function(el){
      if(el._mx) return; el._mx = 1;
      var raw = el.dataset.ends.trim().replace(' ', 'T');
      if(/^\d{4}-\d\d-\d\d$/.test(raw)) raw += 'T23:59';
      if(!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw += ':00+03:00'; // Amman, UTC+3 all year
      var end = Date.parse(raw); if(isNaN(end)) return;
      var out = el.querySelector('[data-t]');
      function pad(n){ return (n < 10 ? '0' : '') + n; }
      function tick(){
        var s = Math.floor((end - Date.now()) / 1000);
        if(s <= 0){ el.hidden = true; return; }
        el.hidden = false;
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
        out.textContent = (d ? d + 'd ' : '') + pad(h) + ' : ' + pad(m) + ' : ' + pad(s % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-copy]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var code = b.dataset.copy, html = b.innerHTML;
    var done = function(){ b.innerHTML = '<b>' + (b.dataset.done || 'Copied!') + '</b>'; setTimeout(function(){ b.innerHTML = html; }, 1600); };
    if(navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  }, true);

  function init(){ [].forEach.call(document.querySelectorAll('[data-mxh]'), hero); timers(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
